import React from "react";

function Pagination({ currentPage, totalPages, basePath }) {
  const handlePageChange = (page) => {
    // Перенаправление на новую страницу
    window.location.href = `${basePath}?page=${page}`;
  };

  return (
    <div className="flex items-center justify-center mt-4">
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 disabled:opacity-50"
      >
        Назад
      </button>
      <span className="px-4">
        {currentPage} / {totalPages}
      </span>
      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 disabled:opacity-50"
      >
        Вперед
      </button>
    </div>
  );
}

export default Pagination;
